import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getToken, clearUser } from './auth';
import { message } from 'antd';

// Token 失效标志，用于防止重复弹窗和重复跳转
let isTokenExpired = false;

export const http = axios.create({
  timeout: 30 * 1000,
});

http.interceptors.request.use(
  (config) => {
    // @ts-ignore
    config.headers = {
      ...config.headers,
      'x-token': getToken(),
      // Authorization: `Bearer ${getToken()}`,
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  (response) => {
    // console.log('response', response)
    if (response.data.errorCode === 10006) {
      // Token 失效时，只处理一次
      if (!isTokenExpired) {
        isTokenExpired = true;
        message.error(response?.data.errorMsg || 'Token 已失效，请重新登录');
        clearUser();
        // 使用 window.location 确保页面完全刷新，终止所有请求
        window.location.href = '/auth/login';
      }
      // 返回一个被拒绝的 Promise，终止后续处理
      return Promise.reject(new Error('Token expired'));
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export function httpRequest<T = any, R = AxiosResponse<T>, D = any>(config: AxiosRequestConfig<D>): Promise<R> {
  return http<T, R, D>(config).then((resp: any) => {
    if (resp.status === 200) {
      return resp.data;
    }

    return resp;
  });
}

interface IRequest {
  <T = any>(url: string, opts: AxiosRequestConfig): Promise<T>; // getResponse 默认是 false， 因此不提供该参数时，只返回 data
  <T = any>(url: string): Promise<T>; // 不提供 opts 时，默认使用 'GET' method，并且默认返回 data
}

export const request: IRequest = (url: string, opts: any = { method: 'GET' }) => {
  return new Promise((resolve, reject) => {
    // console.log({ opts });
    http({
      ...opts,
      url,
    })
      .then((response) => {
        console.log(response);
        if (response.status === 200 && (opts?.isFile || response?.data.success)) {
          resolve(opts?.isFile ? response : response.data);
        } else {
          // @ts-ignore
          message.error(response?.data.errorMsg || response?.data.msg || response?.message);
          reject(response.data);
        }
      })
      .catch((error) => {
        message.error(error?.errorMsg || '系统错误');
        reject(error);
      });
  });
};
